import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, Output, QueryList, Renderer2, SimpleChanges, ViewChild, ViewChildren } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { MatAutocompleteTrigger } from '@angular/material/autocomplete';
import { MatCheckbox, MatCheckboxChange } from '@angular/material/checkbox';
import { MatSelect } from '@angular/material/select';
import { MatSlider } from '@angular/material/slider';
import { ActivatedRoute } from '@angular/router';
import { concatMap, takeWhile } from 'rxjs';
import { City, Country, State } from 'src/app/models/master-data.model';
import { MasterDataService } from 'src/app/services/master-data.service';
import { OemService } from 'src/app/services/oem/oem.service';
import { ProductsService } from 'src/app/services/products.service';
import { AllProductService } from 'src/app/services/shared/product-settings/all-products.service';
import { SpecificationService } from 'src/app/services/shared/product-settings/specification.service';

@Component({
  selector: 'app-products-search-filter',
  templateUrl: './products-search-filter.component.html',
  styleUrls: ['./products-search-filter.component.scss']
})
export class ProductsSearchFilterComponent {
  @Input() data: any[] = [];
  @Input() filterColumns: any;
  @Input() searchKeyword: string = '';
  @Input() heading!: string;
  @Input() isProducts: boolean = false;
  @Input() type: string = '';
  @Input() id: string = '';
  @ViewChildren(MatAutocompleteTrigger) autoCompletes!: QueryList<MatAutocompleteTrigger>;
  @Input() isCatalogSection: boolean = false;
  @Input() catalogData: any[] = [];
  specificationsData: any = []
  @Output() filterFormFields = new EventEmitter<any>();

  filteredProductCatalogData: any[] = [];

  filteredBrands: any[] | undefined;

  dataObj: any[] = [];
  dataObj2: any[] = [];
  filteredObj: any[] = [];

  visible = true;
  selectable = true;
  removable = true;
  addOnBlur = false;
  isRangeSubmit: boolean = false;

  showNoRecordsFounds: boolean = true;
  filterObject: any;
  countries!: any[];
  states!: any[];
  cities!: any[];
  brands!: any[];
  specialities!: any[];
  products!: any[];
  specifications!: any[];
  shapes!: any[];
  models!: any[];
  sizes!: any[];
  filterSpecifications!: any[];
  sampleTypes!: any[];
  applications!: any[];
  textSpecifications: any;
  countryControl = new FormControl();
  stateControl = new FormControl();
  cityControl = new FormControl();
  filteredCountries: Country[] | undefined;
  filteredStates: State[] | undefined;
  filteredCities: City[] | undefined;
  lightSources!: any[];
  configurations!: any[];
  intensityAt1ms!: any[];
  options!: any[];
  params: any;
  brandId: string = '';
  brandName: string = '';
  categories: any[] = [];
  filteredCategories: any[] = [];
  filterForm!: FormGroup;

  res: FormGroup = new FormGroup({
    searchKeyword: new FormControl(null),
    country: new FormControl(null),
    state: new FormControl(null),
    city: new FormControl(null),
    brandIds: new FormControl([]),
    categoryIds: new FormControl([]),
    specifications: new FormControl([])
  });


  @Input() brandProfileProducts: any = '';
  @ViewChild('filterMatSelect') filterMatSelect!: MatSelect;
  isSpecificationLoading: boolean = false;

  filterControls = ['keywords', 'country', 'state', 'city', 'categories', 'brands'];
  constructor(
    private readonly masterDataService: MasterDataService,
    private oemService: OemService,
    private allProductService: AllProductService,
    private route: ActivatedRoute,
    private specificationService: SpecificationService,
    private productsService: ProductsService,
    private fb: FormBuilder,
    private renderer: Renderer2,
    private cdr: ChangeDetectorRef
  ) {
    window.addEventListener('scroll', this.scrollEvent, true);
  }
  scrollEvent = (event: any): void => {
    const target = event.target as HTMLElement
    const isScrollingInsidePanel = this.autoCompletes.some(autoComplete => {
      if (autoComplete.panelOpen) {
        const panel = autoComplete.autocomplete.panel;
        return panel && panel.nativeElement.contains(target);
      }
      return false;
    })
    if (!isScrollingInsidePanel) {
      this.closeAllPanels();
    }
  }

  closeAllPanels() {
    this.autoCompletes.forEach(autoComplete => {
      if (autoComplete.panelOpen) {
        autoComplete.closePanel();
      }
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.dataObj = this.data;
    if (this.data && this.data.length > 0) {
      this.brands = Array.from(new Set(this.data.map((item: any) => item.categoryName && item.oemName.trim()))).sort((a, b) => a.localeCompare(b));
      this.filteredBrands = this.brands;
      this.categories = Array.from(new Set(this.data.map((item: any) => item.categoryName && item.categoryName.trim()))).sort((a, b) => a.localeCompare(b));
      this.filteredCategories = this.categories;
    }
  }
  ngOnInit(): void {
    this.initializeForm();
    if (this.searchKeyword && this.searchKeyword !== '') {
      this.getFilterSpecificationsByType(this.searchKeyword);
    } else if (this.searchKeyword === '' || this.searchKeyword === null) {
      this.isSpecificationLoading = true;
    }
    this.loadCountries('');
  }


  onExpansionChange(expanded: boolean, spec: any) {
    if (expanded) {
      const fromControl = this.filterForm?.get(spec.specificationName + 'From');
      if (fromControl && fromControl?.value == null) {
        fromControl?.setValue(spec.numberValues.min);
      }
    }
  }

  applyFilter(): void {
    this.res?.get('searchKeyword')?.setValue(this.searchKeyword);
    const { country, state, city, zipCode, brands, categories } = this.filterForm.value;

    if (country && country) {
      this.res?.get('country')?.setValue(country)
      this.loadStates(country);
    } else if (!country || country.length === 0) {
      this.res?.get('country')?.setValue(null);
    }

    if (state && state.length > 0) {
      this.res?.get('state')?.setValue(state)
      this.loadCities(state);
    } else if (!state || state.length === 0) {
      this.res?.get('state')?.setValue(null);
    }

    if (city && city.length > 0) {
      this.res?.get('city')?.setValue(city)
    } else if (!city || city.length === 0) {
      this.res?.get('city')?.setValue(null);
    }


    if (brands && brands.length > 0) {
      const brandIds = Array.from(
        new Set(
          this.data
            .filter((item: any) => brands.some((brand: any) => brand.trim() === item.oemName.trim()))
            .map((item: any) => item.oemId)
        )
      );
      this.res?.get('brandIds')?.setValue(brandIds)
    } else if (!brands || brands.length === 0) {
      this.res?.get('brandIds')?.setValue([]);
    }

    if (categories && categories.length > 0) {
      const categoryIds = Array.from(
        new Set(
          this.data
            .filter((item: any) => categories.some((category: any) => category.trim() === item.categoryName.trim()))
            .map((item: any) => item.categoryId)
        )
      );
      this.res?.get('categoryIds')?.setValue(categoryIds)
    } else if (!categories || categories.length === 0) {
      this.res?.get('categoryIds')?.setValue([]);
    }

    let specifications = this.filterSpecifications.map((spec: any) => {
      let fromValue = null;
      let toValue = null;
      if (spec.specificationType === 'Text') {
        fromValue = this.filterForm.get(spec.specificationName)?.value;
      } else if (spec.specificationType === 'Number') {
        fromValue = this.filterForm.get(`${spec.specificationName}From`)?.value;
        toValue = this.filterForm.get(`${spec.specificationName}To`)?.value;
      }
      if (this.isRangeValueEmpty(fromValue) && this.isRangeValueEmpty(toValue)) {
        return;
      }

      if (fromValue && this.isRangeValueEmpty(toValue)) {
        return {
          name: spec.specificationName,
          fromValue: fromValue,
          isRange: spec.isRange,
          type: spec.specificationType,
        };
      } else if(toValue && this.isRangeValueEmpty(fromValue)) {
        return {
          name: spec.specificationName,
          fromValue: 0,
          toValue: toValue,
          isRange: spec.isRange,
          type: spec.specificationType,
        };
      }

      if (fromValue && toValue) {
        return {
          name: spec.specificationName,
          fromValue: fromValue,
          toValue: toValue,
          type: spec.specificationType,
        };
      }
      return;
    });
    specifications = specifications.filter((spec: any) => spec !== undefined && spec !== null);
    if (specifications && specifications.length > 0) {
      this.res?.get('specifications')?.setValue(specifications)
    }

    this.filterFormFields.emit(this.res?.value);
  }

  loadCountries(continentName: string) {
    let pageNumber = 0;
    let pageSize = 250;
    let allCountries: any[] = [];
    let morePages = true;

    this.masterDataService.getCountries(pageNumber, pageSize, '', [continentName])
      .pipe(
        takeWhile(() => morePages),
        concatMap(response => {
          if (response.data.length === 0) {
            morePages = false;
            return [];
          }
          allCountries = allCountries.concat(response.data);
          pageNumber++;
          return this.masterDataService.getCountries(pageNumber, pageSize, '', [continentName]);
        })
      )
      .subscribe(data => {
        allCountries = allCountries.concat(data.data);
        this.countries = allCountries;
        this.filteredCountries = allCountries;
      });
  }

  loadStates(countryName: string) {
    let pageNumber = 0;
    let pageSize = 100;
    let allStates: any[] = [];
    let morePages = true;
    this.masterDataService.getStates(pageNumber, pageSize, '', [countryName])
      .pipe(
        takeWhile(() => morePages),
        concatMap(response => {
          if (response.data.length === 0) {
            morePages = false;
            return [];
          }
          allStates = allStates.concat(response.data);
          pageNumber++;
          return this.masterDataService.getStates(pageNumber, pageSize, '', [countryName]);
        })
      )
      .subscribe(data => {
        allStates = allStates.concat(data.data);
        this.states = allStates;
        this.filteredStates = allStates;
      });
  }

  loadCities(stateName: string) {
    let pageNumber = 0;
    let pageSize = 100;
    let allCities: any[] = [];
    let morePages = true;
    this.masterDataService.getCities(pageNumber, pageSize, '', [stateName])
      .pipe(
        takeWhile(() => morePages),
        concatMap(response => {
          if (response.data.length === 0) {
            morePages = false;
            return [];
          }
          allCities = allCities.concat(response.data);
          pageNumber++;
          return this.masterDataService.getCities(pageNumber, pageSize, '', [stateName]);
        })
      )
      .subscribe(data => {
        allCities = allCities.concat(data.data);
        this.cities = allCities;
        this.filteredCities = allCities;
      });
  }

  loadBrands() {
    this.oemService.getBrandsList().subscribe({
      next: (response) => {
        this.brands = response.data;
        this.filteredBrands = response.data;
      },
      error: (error) => {
      }
    });
  }

  resetFilters() {
    const inputElement = document.querySelector('input[placeholder="Search By Keyword"]') as HTMLInputElement;
    if (inputElement) {
      inputElement.value = '';
    }
    this.filterForm.reset();
    this.isRangeSubmit = false;
    const searchKeyword = this.res.get('searchKeyword')?.value || '';
    this.res.reset();
    this.res.get('searchKeyword')?.setValue(searchKeyword);
    this.applyFilter();
  }
  isArray(value: any): boolean {
    return Array.isArray(value);
  }


  add(controlName: string, event: any): void {
    const value = event?.value?.trim() || event?.name || (typeof controlName === 'string' ? controlName.trim() : '');
    if (value) {
      const currentValues = this.filterForm.get(controlName)?.value || [];
      if (!currentValues.includes(value)) {
        this.filterForm.get(controlName)?.setValue([...currentValues, value]);
      }
    }

    this.searchSuggestions = [];
    this.isSugestionOpen = false;

    const input = event?.input || document.querySelector('input[placeholder="Search By Keyword"]');
    if (input) {
      input.value = '';
    }
  }

  remove(controlName: string, item: string | number): void {
    const control = this.filterForm.get(controlName);

    if (control && typeof control.value !== 'number') {
      if (controlName === 'country' || controlName === 'state' || controlName === 'city') {

        this.filterForm.get(controlName)?.setValue(null);
      } else if(controlName.includes('From') || controlName.includes('To')) {

        this.filterForm.get(controlName)?.setValue(null);
        if(controlName.includes('To')) {
          this.isRangeSubmit = false;
        } else {
          this.isRangeSubmit = true;
        }
      } else {
        const currentValues = control.value || [];
        const index = currentValues.indexOf(item);
        if (index >= 0) {
          currentValues.splice(index, 1);
          control.setValue(currentValues);
        }
      }

      this.applyFilter();
    } else if (control && typeof control.value === 'number') {
      const currentValues = control.value
      control.setValue(null);
    }
  }

  onOptionSelected(event: any, filterType: string): void {
    let currentValues: any[] = [];
    switch (filterType) {
      case 'continent':
      case 'country':
        this.filterForm.get('country')?.setValue((event?.option?.value) ? event.option?.value : '');
        break;
      case 'state':
        this.filterForm.get('state')?.setValue((event?.option?.value) ? event.option?.value : '');
        break;
      case 'city':
        this.filterForm.get('city')?.setValue((event?.option?.value) ? event.option?.value : '');
        break;
      case 'brand':
        currentValues = this.filterForm.get('brands')?.value || [];
        if (!currentValues.includes(event.option.value)) {
          this.filterForm.get('brands')?.setValue([...currentValues, event.option.value]);
        }
        break;
      case 'category':
        currentValues = this.filterForm.get('categories')?.value || [];
        if (!currentValues.includes(event.option.value)) {
          this.filterForm.get('categories')?.setValue([...currentValues, event.option.value]);
        }
        break;
      default:
        break;
    }
    this.applyFilter();
  }

  getFilterSpecificationsByType(searchKeyword: any): void {
    this.specificationService.getSpecificationsBySearchKeyword(searchKeyword).subscribe(
      (response: any) => {
        this.filterSpecifications = response;
        if(!this.filterSpecifications || this.filterSpecifications.length === 0) {
          this.filterSpecifications = [];
          this.isSpecificationLoading = true;
          return;
        }
        const mergedSpecsMap = new Map();

        this.filterSpecifications
          .filter(s => s.specificationName && s.specificationName.trim() !== "")
          .forEach(spec => {
            const name = spec.specificationName;
            if (!mergedSpecsMap.has(name)) {
              mergedSpecsMap.set(name, { ...spec }); // clone the first occurrence
            } else {
              const existing = mergedSpecsMap.get(name);

              if (spec.specificationType === 'Number') {
                existing.numberValues = {
                  min: Math.min(existing.numberValues?.min ?? 0, spec.numberValues?.min ?? 0),
                  max: Math.max(this.convertDecimalToInteger(existing.numberValues?.max) ?? 0, this.convertDecimalToInteger(spec.numberValues?.max) ?? 0)
                };
              } else if (spec.specificationType === 'Text') {
                const combined = new Set([
                  ...(existing.textValues || []),
                  ...(spec.textValues || [])
                ]);
                existing.textValues = Array.from(combined);
              }

              mergedSpecsMap.set(name, existing);
            }
          });

        this.filterSpecifications = Array.from(mergedSpecsMap.values());


        this.filterSpecifications?.forEach((spec: any) => {
          if (spec.specificationType === 'Text') {
            if (!this.filterControls.includes(spec.specificationName) && (spec.specificationName !== "" || spec.specificationName !== null)) {
              this.filterForm.addControl(spec.specificationName, new FormControl([]));
              this.filterControls.push(spec.specificationName);
            }
          } else if (spec.specificationType === 'Number') {
            if (!this.filterControls.includes(`${spec.specificationName}From`) && (spec.specificationName !== "" || spec.specificationName !== null)) {
              this.filterForm.addControl(`${spec.specificationName}From`, new FormControl());
              this.filterControls.push(`${spec.specificationName}From`);
            }
            if (!this.filterControls.includes(`${spec.specificationName}To`) && (spec.specificationName !== "" || spec.specificationName !== null)) {
              this.filterForm.addControl(`${spec.specificationName}To`, new FormControl());
              this.filterControls.push(`${spec.specificationName}To`);
            }
          }
        });
        this.isSpecificationLoading = true;
      },
      (error) => {
        this.isSpecificationLoading = true;
      }
    );
  }


  searchSuggestions: any[] = [];
  isSugestionOpen = false;
  searchSuggestion(event: any): void {
    const query = event?.target?.value?.trim() || '';
    if (query) {
      if (this.brandProfileProducts != '') {
        this.oemService.searchOemSuggestions(this.brandId, query, this.brandProfileProducts).subscribe(
          (response: any) => {
            this.searchSuggestions = response.data || [];
            this.isSugestionOpen = this.searchSuggestions.length > 0;
          },
          (error) => {
            this.searchSuggestions = [];
            this.isSugestionOpen = false;
          }
        );
      } else {
        this.productsService.searchSuggestion(this.brandId, query).subscribe(
          (response: any) => {
            this.searchSuggestions = response.data || [];
            this.isSugestionOpen = this.searchSuggestions.length > 0;
          },
          (error) => {
            this.searchSuggestions = [];
            this.isSugestionOpen = false;
          }
        );
      }
    } else {
      this.searchSuggestions = [];
      this.isSugestionOpen = false;
    }
  }

  selectedSuggestion(suggestion: any): void {
    if (suggestion?.name) {
      const value = suggestion.type.toLowerCase().includes("catelog") ? suggestion.id : suggestion.name;
      this.add('keywords', { value });
      const inputElement = document.querySelector('input[placeholder="Search By Keyword"]') as HTMLInputElement;
      if (inputElement) {
        inputElement.value = '';
      }


      this.searchSuggestions = [];
      this.isSugestionOpen = false;
    }
  }

  toggleSuggestions() {
    this.isSugestionOpen = !this.isSugestionOpen;
  }

  searchCatalogRelatedProducts(event: any) {
    const searchKeyword = event.target?.value;
    if (searchKeyword === '' || searchKeyword === null || searchKeyword === undefined) {
      this.filteredProductCatalogData = this.catalogData;
    } else if (searchKeyword !== "") {
      this.filteredProductCatalogData = this.catalogData.filter(data => data?.productName?.toLowerCase().includes(searchKeyword.toLowerCase()));
    }
  }

  onInputChange(event: any, type: string) {
    const searchKeyword = event.target?.value ?? '';
    switch (type) {
      case 'country':
        this.filteredCountries = this.filterDropDown(searchKeyword, this.countries, 'country', true)
        break;
      case 'state':
        this.filteredStates = this.filterDropDown(searchKeyword, this.states, 'state', true);
        break;
      case 'city':
        this.filteredCities = this.filterDropDown(searchKeyword, this.cities, 'city', true);
        break;
      case 'brand':
        this.filteredBrands = this.filterDropDown(searchKeyword, this.brands, 'brand', false);
        break;
      default:
        break;
    }
  }

  filterDropDown(searchKeyword: any, originalData: any, type: string, isRegion: boolean) {
    if (searchKeyword === '' || searchKeyword === null || searchKeyword === undefined) {
      return originalData ?? [];
    } else if (searchKeyword) {
      if (isRegion) {
        return originalData.filter((data: any) => data?.[`${type}Name`]?.toLowerCase().includes(searchKeyword.toLowerCase())) ?? [];
      } else {
        return originalData.filter((data: any) => data?.toLowerCase().includes(searchKeyword.toLowerCase())) ?? [];
      }
    }
  }

  initializeForm() {
    this.filterForm = this.fb.group({
      keywords: new FormControl(null),
      country: new FormControl(null),
      state: new FormControl(null),
      city: new FormControl(null),
      brands: new FormControl(null),
      categories: new FormControl(null),
      year: new FormControl(null),
    });
  }

  rangeValueChange(event: any, formControlName: any, name: any) {
    this.filterForm.get(formControlName)?.setValue(event?.target?.value);
    if (this.filterForm.get(name + 'From')?.value || this.filterForm.get(name + 'To')?.value) {
      this.isRangeSubmit = true;
    } else {
      this.isRangeSubmit = false;
    } 
  }

  onSelectionChange(event: any, formControlName: any) {
    this.filterForm.get(formControlName)?.setValue(event.value);
    this.applyFilter();
  }

  convertDecimalToInteger(value: any) {
    const valuestr = value.toString() ?? '';
    if (valuestr == '') {
      return 0;
    } else if (valuestr.includes('e') || valuestr.includes('E')) {
      const base = valuestr.split(/[eE]/)[0];
      return parseInt(base.split('.')[0], 10);
    }
    else if (valuestr.includes('.')) {
      return parseInt(valuestr.split('.')[0]) + 1;
    } else {
      return parseInt(valuestr);
    }
  }

  removeRange(baseControlName: string) {
    this.filterForm.get(baseControlName + 'From')?.setValue(null);
    this.filterForm.get(baseControlName + 'To')?.setValue(null);
    this.res.get('specifications')?.setValue(this.res.get('specifications')?.value.filter((item: any) => item.name !== baseControlName))
    this.applyFilter();
  }

  removeTextValues(controlName: any, value: any, formControl: any) {
    formControl.setValue(formControl.value.filter((item: any) => item !== value));
    if(!formControl.value || formControl.value.length === 0) {
      formControl.setValue([]);
      this.filterForm.get(controlName)?.setValue(null);
    }
    this.res.get('specifications')?.setValue(this.res.get('specifications')?.value.filter((item: any) => item.name !== controlName));
    this.applyFilter();
  }

  isRangeValueEmpty(value: any) {
    if(value === null || value === 0 || value === undefined || value.length === 0 || value === '') {
      return true;
    }
    return false;
  }

}
